import { type HttpEvent, type HttpHandlerFn, type HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { type Observable } from 'rxjs';
import { Environment } from '../environment';

export function httpHostInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
  environment = inject(Environment),
): Observable<HttpEvent<unknown>> {
  if (!/^\/?api\//i.test(request.url)) {
    return next(request);
  }

  const url = `${environment.apiUrl.replace(/\/$/, '')}/${request.url.replace(/^\//, '')}`;

  return next(request.clone({ url }));
}
